export default {
  setEntries (state, entries) {
    state.entries = entries
  }
}
